import { eventsKeys } from '../constants';
import send from './send';

export default () => {
  send(eventsKeys.CLICK_DOWNLOAD_AND_SHARE_ON_MINISITE);
};
